<div class="ig-card" *ngIf="post">
  <!-- HEADER -->
  <div class="ig-card__header">
    <div class="ig-card__avatar" (click)="hasProject ? goProjectProfile() : goAuthorProfile()">
      <img *ngIf="primaryAvatarUrl" [src]="primaryAvatarUrl" class="ig-card__avatar-img" alt="" />
      <span *ngIf="!primaryAvatarUrl" class="ig-card__avatar-initial">{{ primaryInitial }}</span>
    </div>
    <div class="ig-card__header-text">
      <span class="ig-card__username" (click)="hasProject ? goProjectProfile() : goAuthorProfile()">{{ primaryDisplay }}</span>
      <span class="ig-card__author-sub" *ngIf="hasProject">
        {{ "socialFeed.byUser" | transloco }}
        <a (click)="goAuthorProfile(); $event.stopPropagation()">{{ authorDisplay }}</a>
      </span>
    </div>
    <span class="ig-card__sponsored-badge" *ngIf="post.isSponsored">
      <i class="pi pi-megaphone"></i> {{ "socialFeed.sponsored" | transloco }}
    </span>
    <button
      type="button"
      class="ig-card__follow-btn"
      *ngIf="canFollowProject"
      [disabled]="followProjectBusy"
      (click)="followProjectFromCard()"
    >
      <p-progressSpinner *ngIf="followProjectBusy" [style]="{ width: '12px', height: '12px' }"></p-progressSpinner>
      <span *ngIf="!followProjectBusy">
        <i class="pi pi-user-plus"></i>
        {{ "socialFeed.follow" | transloco }}
      </span>
    </button>
    <button class="ig-card__more" *ngIf="currentUserId" (click)="showActions = !showActions">
      <i class="pi pi-ellipsis-h"></i>
    </button>
    <div class="ig-card__dropdown" *ngIf="showActions">
      <button *ngIf="isOwner && post.status === 'Active'" (click)="archive(); showActions = false">{{ "socialFeed.archive" | transloco }}</button>
      <button *ngIf="isOwner && post.status === 'Archived'" (click)="unarchive(); showActions = false">{{ "socialFeed.restore" | transloco }}</button>
      <button *ngIf="isOwner" class="danger" (click)="deletePost(); showActions = false">{{ "socialFeed.delete" | transloco }}</button>
      <button *ngIf="!isOwner" (click)="reportClick(); showActions = false">{{ "socialFeed.reportShort" | transloco }}</button>
    </div>
  </div>

  <!-- MEDIA CAROUSEL -->
  <div class="ig-card__media" *ngIf="sortedMedia().length"
       [style.aspect-ratio]="mediaAspectRatio"
       (dblclick)="likeFromDoubleTap()"
       (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <div class="ig-card__slides" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'">
      <div class="ig-card__slide" *ngFor="let media of sortedMedia(); let i = index">
        <img *ngIf="media.mediaType === 'Image'"
             [src]="mediaUrl(media.url, media.mediaType)"
             alt=""
             draggable="false"
             (load)="i === 0 && onFirstMediaImageLoad($event)" />
        <ng-container *ngIf="media.mediaType === 'Video'">
          <ng-container *ngIf="hlsPlaybackEnabled; else legacyVideo">
            <app-hls-video-player #vid [videoId]="media.id" [active]="videoActive(i)"></app-hls-video-player>
            <!-- Mesma camada de toque do <video> legado (ver ng-template legacyVideo abaixo):
                 clique = play/pause, duplo = curtir. #vid aqui aponta pra instância do
                 componente (exportAs), que expõe paused/play()/pause() equivalentes ao
                 <video> nativo. -->
            <div class="ig-card__video-tap"
                 (click)="onVideoTap(vid)"
                 (dblclick)="onVideoDblTap(); $event.stopPropagation()"></div>
          </ng-container>
          <ng-template #legacyVideo>
            <video #vid
                   [attr.src]="videoSrc(media, i)"
                   [attr.poster]="videoPoster(media)"
                   preload="metadata"
                   controls
                   playsinline
                   (loadedmetadata)="i === 0 && onFirstMediaVideoMeta($event)"></video>
            <!-- Camada de toque: captura clique (play/pause) e double-click (curtir),
                 impedindo o fullscreen nativo do vídeo no double-click. A barra de
                 controles (parte de baixo) fica livre p/ seek/volume/tela cheia pelo botão. -->
            <div class="ig-card__video-tap"
                 (click)="onVideoTap(vid)"
                 (dblclick)="onVideoDblTap(); $event.stopPropagation()"></div>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <div class="ig-card__heart-burst" *ngIf="showHeart" aria-hidden="true">
      <i class="pi pi-heart-fill"></i>
    </div>
    <button class="ig-card__nav ig-card__nav--prev" *ngIf="currentSlide > 0"
            (click)="prevSlide(); $event.stopPropagation()"
            (dblclick)="$event.stopPropagation()">
      <i class="pi pi-chevron-left"></i>
    </button>
    <button class="ig-card__nav ig-card__nav--next" *ngIf="currentSlide < sortedMedia().length - 1"
            (click)="nextSlide(); $event.stopPropagation()"
            (dblclick)="$event.stopPropagation()">
      <i class="pi pi-chevron-right"></i>
    </button>
    <div class="ig-card__dots" *ngIf="sortedMedia().length > 1">
      <span *ngFor="let m of sortedMedia(); let i = index" class="ig-card__dot" [class.active]="i === currentSlide" (click)="currentSlide = i"></span>
    </div>
  </div>

  <!-- ACTIONS BAR -->
  <div class="ig-card__actions">
    <button class="ig-card__action-btn" *ngIf="currentUserId" [class.liked]="likedLocal" (click)="toggleLike()">
      <i class="pi" [ngClass]="likedLocal ? 'pi-heart-fill' : 'pi-heart'"></i>
    </button>
    <button class="ig-card__action-btn" (click)="toggleComments()">
      <i class="pi pi-comment"></i>
    </button>
  </div>

  <!-- LIKES -->
  <div class="ig-card__likes" *ngIf="post.likesCount > 0">
    {{ post.likesCount }} {{ post.likesCount === 1 ? ('socialFeed.like' | transloco) : ('socialFeed.likes' | transloco) }}
  </div>

  <!-- CAPTION -->
  <div class="ig-card__caption" *ngIf="post.caption">
    <span class="ig-card__caption-user" (click)="goAuthorProfile()">{{ authorDisplay }}</span>
    {{ post.caption }}
  </div>

  <!-- VIEW COMMENTS LINK -->
  <button class="ig-card__view-comments" *ngIf="post.commentsCount > 0 && !showComments" (click)="toggleComments()">
    {{ 'socialFeed.viewAllComments' | transloco: { count: post.commentsCount } }}
  </button>

  <!-- INLINE COMMENTS -->
  <div class="ig-card__comments" *ngIf="showComments">
    <div *ngIf="commentsLoading" class="ig-card__comments-loading">
      <p-progressSpinner [style]="{ width: '24px', height: '24px' }"></p-progressSpinner>
    </div>

    <div class="ig-card__comment-thread" *ngFor="let c of comments">
      <div class="ig-card__comment">
        <span class="ig-card__comment-user">{{ commentAuthorDisplay(c) }}</span>
        <span class="ig-card__comment-body">{{ c.body }}</span>
      </div>

      <div class="ig-card__comment-actions">
        <button
          type="button"
          *ngIf="currentUserId"
          class="ig-card__comment-action"
          (click)="toggleReplyInput(c)"
        >{{ 'socialFeed.reply' | transloco }}</button>

        <button
          type="button"
          class="ig-card__comment-action"
          (click)="toggleReplies(c)"
          [disabled]="c.repliesLoading"
        >
          <ng-container *ngIf="c.repliesLoading">{{ 'socialFeed.loadingReplies' | transloco }}</ng-container>
          <ng-container *ngIf="!c.repliesLoading && !c.repliesLoaded">{{ 'socialFeed.viewReplies' | transloco }}</ng-container>
          <ng-container *ngIf="!c.repliesLoading && c.repliesLoaded && c.repliesExpanded">{{ 'socialFeed.hideReplies' | transloco }}</ng-container>
          <ng-container *ngIf="!c.repliesLoading && c.repliesLoaded && !c.repliesExpanded">{{ 'socialFeed.showRepliesCount' | transloco: { count: c.replies.length } }}</ng-container>
        </button>

        <button
          *ngIf="canDeleteComment(c)"
          type="button"
          class="ig-card__comment-action ig-card__comment-action--danger"
          (click)="deleteTopLevelComment(c)"
        >{{ 'socialFeed.deleteComment' | transloco }}</button>

        <button
          *ngIf="canReportComment(c)"
          type="button"
          class="ig-card__comment-action"
          (click)="reportCommentClick(c)"
        >{{ 'socialFeed.reportComment' | transloco }}</button>
        <button
          *ngIf="canReportComment(c)"
          type="button"
          class="ig-card__comment-action"
          (click)="reportUserClick(c)"
        >{{ 'socialFeed.reportUser' | transloco }}</button>
      </div>

      <!-- Reply compose -->
      <div class="ig-card__reply-compose" *ngIf="c.isReplying">
        <input
          type="text"
          [(ngModel)]="c.replyBody"
          [placeholder]="'socialFeed.replyPlaceholder' | transloco"
          (keydown.enter)="sendReply(c)"
          [disabled]="c.replySending"
          [maxlength]="commentMaxLength"
        />
        <button
          type="button"
          class="ig-card__post-btn"
          [disabled]="!c.replyBody.trim() || c.replySending"
          (click)="sendReply(c)"
        >
          <p-progressSpinner *ngIf="c.replySending" [style]="{ width: '14px', height: '14px' }"></p-progressSpinner>
          <span *ngIf="!c.replySending">{{ 'socialFeed.publish' | transloco }}</span>
        </button>
      </div>

      <!-- Replies list -->
      <ul class="ig-card__replies" *ngIf="c.repliesExpanded && c.replies.length">
        <li class="ig-card__reply" *ngFor="let r of c.replies">
          <div class="ig-card__comment">
            <span class="ig-card__comment-user">{{ commentAuthorDisplay(r) }}</span>
            <span class="ig-card__comment-body">{{ r.body }}</span>
          </div>
          <div class="ig-card__comment-actions">
            <button
              type="button"
              *ngIf="currentUserId"
              class="ig-card__comment-action"
              (click)="toggleReplyInput(c, r.authorNickname || r.authorName)"
            >{{ 'socialFeed.reply' | transloco }}</button>
            <button
              *ngIf="canDeleteComment(r)"
              type="button"
              class="ig-card__comment-action ig-card__comment-action--danger"
              (click)="deleteReply(c, r)"
            >{{ 'socialFeed.deleteComment' | transloco }}</button>
            <button
              *ngIf="canReportComment(r)"
              type="button"
              class="ig-card__comment-action"
              (click)="reportCommentClick(r)"
            >{{ 'socialFeed.reportComment' | transloco }}</button>
            <button
              *ngIf="canReportComment(r)"
              type="button"
              class="ig-card__comment-action"
              (click)="reportUserClick(r)"
            >{{ 'socialFeed.reportUser' | transloco }}</button>
          </div>
        </li>
      </ul>
    </div>

    <p *ngIf="!commentsLoading && !comments.length" class="ig-card__no-comments">{{ 'socialFeed.noComments' | transloco }}</p>
  </div>

  <!-- TIMESTAMP -->
  <div class="ig-card__time">{{ post.createdAt | timeAgo }}</div>

  <!-- ADD COMMENT -->
  <div class="ig-card__add-comment" *ngIf="currentUserId">
    <input type="text" [(ngModel)]="newComment" [placeholder]="'socialFeed.addCommentPlaceholder' | transloco" (keydown.enter)="sendComment()" [disabled]="commentSending" [maxlength]="commentMaxLength" />
    <button class="ig-card__post-btn" [disabled]="!newComment.trim() || commentSending" (click)="sendComment()">
      <p-progressSpinner *ngIf="commentSending" [style]="{ width: '14px', height: '14px' }"></p-progressSpinner>
      <span *ngIf="!commentSending">{{ 'socialFeed.publish' | transloco }}</span>
    </button>
  </div>
</div>

<!-- DELETE COMMENT/REPLY CONFIRM MODAL -->
<p-dialog
  [(visible)]="deleteConfirmVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!deleteInFlight"
  [dismissableMask]="!deleteInFlight"
  [showHeader]="false"
  styleClass="ig-card__delete-dialog"
  [style]="{ width: 'min(420px, calc(100vw - 32px))' }"
>
  <div class="ig-card__delete-body">
    <i class="pi pi-exclamation-triangle ig-card__delete-icon"></i>
    <p class="ig-card__delete-message">{{ 'socialFeed.deleteCommentConfirm' | transloco }}</p>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'common.buttons.cancel' | transloco"
      [text]="true"
      [disabled]="deleteInFlight"
      (onClick)="cancelDelete()"
    />
    <p-button
      [label]="'socialFeed.deleteComment' | transloco"
      icon="pi pi-trash"
      severity="danger"
      [loading]="deleteInFlight"
      (onClick)="confirmDelete()"
    />
  </ng-template>
</p-dialog>
